import React, { ReactNode, CSSProperties } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, IconButton, Typography } from "@mui/material";
interface SideDrawerProps {
  title?: string;
  closeDrawer: () => void;
  content: ReactNode;
  hideCloseButton?: boolean;
  style?: CSSProperties;
}
export default function SideDrawer(props: SideDrawerProps) {
  return (
    <div className={"sideBarDrawerContainer"} style={props.style}>
      <AppBar
        position="static"
        // color="primary"
        style={{backgroundColor: '#333333'}}
        className={"sideBarDialogTitle"}
      >
        <Typography variant="h6">{props.title}</Typography>
        {props.hideCloseButton != true && (
          <IconButton onClick={props.closeDrawer}>
            <CloseIcon style={{ color: "white" }} />
          </IconButton>
        )}
      </AppBar>
      <div className={"sideBarDrawerContent"}>{props.content}</div>
    </div>
  );
}
